import { getSearchParams } from '../../utils'

const syncLoginTokenToMSite = (token: string, userinfo: any, redirect: string): Promise<void> => {
  // 安全检查
  if (!token) {
    return Promise.reject(new Error('Token is required'))
  }

  const messageKey = 'loginToken_' + Math.random().toString(36).substr(2, 9)

  // 设置目标域名和路径
  let targetOrigin = process.env.NEXT_PUBLIC_MOBILE_DOMAIN as string

  if (process.env.NODE_ENV !== 'development') {
    const mobileDomain = window.location.hostname.replace('www.', 'm.').replace('wt.', 'mt.')
    targetOrigin = `https://${mobileDomain}`
  }

  let url = `${targetOrigin}/en_US/updateToken/?messageKey=${messageKey}&token=${encodeURIComponent(token)}&userInfo=${encodeURIComponent(userinfo)}&redirect=${encodeURIComponent(redirect || '/')}`

  if (/iPhone/i.test(navigator.userAgent)) {
    setTimeout(() => {
      // 异步让后续代码执行完成，存入token，再执行此处跳转
      window.location.href = url
    })
    return Promise.resolve({ disableRedirect: true })
  }

  const iframe = document.createElement('iframe')
  iframe.src = url
  // 设置iframe样式为隐藏
  iframe.style.display = 'none'

  return new Promise((resolve, reject) => {
    // 设置超时处理
    const timeout = setTimeout(() => {
      cleanup()
      reject(new Error('Token sync timeout'))
    }, 10000) // 10秒超时

    const cleanup = () => {
      window.removeEventListener('message', handler)
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe)
      }
      clearTimeout(timeout)
    }

    const handler = (event: MessageEvent) => {
      // 验证消息来源
      if (event.origin !== targetOrigin) {
        return
      }

      let data: {
        key: string
        success?: boolean
        error?: string
      }
      try {
        data = JSON.parse(event.data)
      } catch (error) {
        console.error('Failed to parse message data:', error)
        return
      }
      // 验证消息key
      if (data?.key === messageKey) {
        cleanup()

        if (data.success) {
          console.log('Token sync successful')
          resolve()
        } else {
          console.error('Token sync failed:', data.error)
          reject(new Error(data.error || 'Token sync failed'))
        }
      }
    }

    // 添加消息监听
    window.addEventListener('message', handler)

    // 添加iframe到页面
    document.body.appendChild(iframe)
  })
}

// 使用示例
//   try {
//     await syncLoginTokenToMSite(token);
//     console.log('Token has been synced to mobile site');
//     // 继续后续操作...
//   } catch (error) {
//     console.error('Failed to sync token:', error);
//     // 处理错误...
//   }

export { syncLoginTokenToMSite }
